
















import Loader from '@/components/common/Loader.vue';
import { Component, Vue } from 'vue-property-decorator';
import { workspaceService } from '@/services/WorkspaceService';

@Component({
  components: { Loader },
})
export default class Logout extends Vue {
  isError = false;
  mounted() {
    workspaceService
      .getWorkspaces()
      .then((data: any) => {
        const workspaces = data.workspaces || [];
        const invitations = data.invitations || [];
        if (workspaces.length || invitations.length) {
          if (workspaces.length > 1 || workspaces.length === 0) {
            this.$router.push('/workspace-switch').catch(() => {});
          } else {
            this.$router.push(`/workspaces/${workspaces[0].id}`).catch(() => {});
          }
        } else {
          this.$router.push('/new-workspace/intro').catch(() => {});
        }
      })
      .catch(() => {
        this.isError = true;
      });
  }
}
